<template>
  <UModal v-model="open">
    <div
      class="w-full flex flex-col items-start items-stretch gap-2 alpha-top p-4 border-4 border-green-800 rounded-lg font-inter"
    >
      <div class="flex flex-row items-center font-bold">
        <span class="mr-1 text-lg">🥇</span>
        <span>Platinum Multi-Site Offer</span>
      </div>
      <h2 class="text-xl text-[#0891f5] font-bold leading-none">
        Update Now > Huge Savings!
      </h2>
      <p>
        Add
        <strong>Full Access</strong>
        to
        <strong>Platinum Sites</strong>
      </p>

      <p v-if="visitingSite" class="text-xl mb-3">
        You are about to visit
        <span
          v-html="
            siteNameToColoredText(visitingSite.slug || visitingSite.cachedSlug)
          "
        />
        as a guest. You will be able to view all the trailers on the site. To
        get full access make sure to upgrade to platinum!
      </p>

      <div class="flex grow flex-row items-stretch gap-2">
        <LifetimeOfferSiteList />
        <LifeTimeUpgradeFrameWithButton @finish-upgrade="close" />
      </div>

      <div
        v-if="visitingSite"
        class="w-full flex flex-col items-center mt-6 mb-3"
      >
        <UButton
          color="yellow"
          variant="soft"
          class="text-lg"
          @click="continueToSiteAsGuest(visitingSite, visitingReleaseId)"
        >
          Continue as Guest
        </UButton>
      </div>
    </div>
  </UModal>
</template>

<script setup>
  defineProps({
    visitingSite: {
      type: Object,
      default: null,
    },
    visitingReleaseId: {
      type: Number,
      default: null,
    },
  })

  const open = defineModel("open", { type: Boolean, default: false })

  const currentSite = inject("currentSite")
  const { continueToSiteAsGuest } = useMembersArea()
  const { siteNameToColoredText } = useSiteSettings(currentSite.value)

  const emit = defineEmits(["close"])
  const close = () => {
    emit("close")
  }
</script>
